import styled from '@emotion/styled';

export const Flags = styled.div` 
  width: 25px;
  height: 15px;
  float: left;
  margin: 5px;
  box-shadow: 0px 3px 5px rgba(0,0,0,0.5);
`;

export const Wrapper = styled.div`    
  width: 100%;
  height: auto;  
  overflow: hidden;
  @media all and (max-width: ${props => props.theme.breakpoints.l}) {
    
  }

  @media all and (max-width: ${props => props.theme.breakpoints.s}) {
 
  }

  @media all and (max-width: ${props => props.theme.breakpoints.xs}) {
    
  }
`;
